__webpack_require__.p = "/weatherscope-dashboard/";